import React from "react";
import moment from "moment";
import logo from "../asset/img/logo.jpeg";
import Barcode from "react-barcode";

const CustomLabel = React.forwardRef(({ order }, ref) => {
  return (
    <div
      ref={ref}
      style={{
        width: "285px",
        // border: "1px solid black",
        paddingTop: "11px",
        paddingBottom: "11px",
        paddingLeft: "14px",
        paddingRight: "14px"
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", }}>

        <div style={{ display: "flex", alignItems: "center", paddingBottom: '6px' }}>
          <img src={logo} className="h-7 w-7" alt="UK Logistics Logo" />

          <div>
            <p style={{ fontSize: "11px", fontWeight: "bold", paddingLeft: "8px", }} className="mb-">
              UK Logistics
            </p>
            <p style={{ fontSize: "8px", paddingLeft: "8px", }} className="mb-">
              India’s Largest Logistics Network – Fast & Reliable Shipping | www.uklogistic.com
            </p>
          </div>

        </div>


        <div style={{ paddingBottom: '8px' }}>

          <p style={{ fontSize: "8px", fontWeight: "bold" }}>
            {order?.deliveryAddress?.name}  <span style={{ fontSize: "8px", fontWeight: "bold", paddingLeft: '6px' }}>(To)</span>
          </p>
          <p style={{ fontSize: "8px" }}>
            {order?.deliveryAddress?.address1},
          </p>
          <p style={{ fontSize: "8px" }}>
            {order?.deliveryAddress?.city}, {order?.deliveryAddress?.stateId?.name} - {order?.deliveryAddress?.zipCode}
          </p>
          <p style={{ fontSize: "8px", marginTop: 0 }}>
            Mobile No. <span style={{ fontSize: "8px", fontWeight: "bold" }}>{order?.deliveryAddress?.phone}</span>
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderTop: "1px solid black",
            borderBottom: "1px solid black",
            width: "100%",
            // padding: "6px 0", // Added padding for better spacing
          }}
        >
          {/* COD and Price Box */}
          <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center" }} className="pb-4">
            <span style={{ fontSize: "14px", fontWeight: "bold" }}> {order?.payment_type === 'cod' ? "COD" : "PREPAID"}</span>
            {order?.payment_type === "cod" ? <span style={{ fontSize: "14px", fontWeight: "bold", paddingLeft: "16px" }}>
              {order?.ProductPrice}
            </span> : ""}
          </div>

          {/* Barcode & AWB Number Box */}
          <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }} className="-mt-2 -mb-2">
            {/* Barcode */}
            <div style={{ display: "flex", gap: "2px", justifyContent: "center" }}>
              <Barcode
                value={order?.order_number || "000000000"}
                format="CODE128"
                width={0.8}
                height={20}
                displayValue={true}
                fontSize={8}
                margin={0}
              />
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center", // Fixed camelCase
            width: "100%",
          }}
        >
          <p style={{ fontSize: "8px", fontWeight: "bold" }}>
            Order No: <span style={{ fontSize: "8px", fontWeight: "normal" }}>{order?.order_number}</span>
          </p>
          <p style={{ fontSize: "8px", fontWeight: "bold" }}>
            Order Date:  <span style={{ fontSize: "8px", fontWeight: "normal" }}> {moment(order?.createdAt).format("MMM DD, YYYY")}</span>
          </p>
        </div>

        <div style={{ width: "100%" }}>
          <p style={{ fontSize: "8px" }}>
            <span style={{ fontWeight: "bold" }}>Fwd Destination Code:</span>{" "}
            {order?.deliveryAddress?.stateId?.name?.toUpperCase() || "N/A"}
          </p>
          <p style={{ fontSize: "8px" }}>
            <span style={{ fontWeight: "bold" }}>Category:</span> UK LOGISTICS
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", paddingTop: '10px' }}>
          <div style={{ display: "flex", gap: "2px" }}>
            <Barcode
              value={order?.awb_number || "000000000"}
              format="CODE128"
              width={1.5}
              height={30}
              displayValue={true}
              fontSize={9}
              margin={0}
            />
          </div>
        </div>

        <div style={{ width: "100%" }}>
          <h3 style={{ fontSize: "9px", fontWeight: "bold" }}>
            Product Details:
          </h3>
          {/* <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              border: "1px solid black",
              textAlign: "center",
              verticalAlign: "middle",
              fontSize: "8px",
            }}
          >
            <thead>
              <tr>
                <th style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }} className="mb-4">SKU</th>
                <th style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }} className="mb-4">Item Name</th>
                <th style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }} className="mb-4">Qty.</th>
                <th style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }} className="mb-4">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }}>
                  {order?.awb_number || "N/A"}
                </td>
                <td style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }}>
                  {order?.ProductName || "N/A"}
                </td>
                <td style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }}>1</td>
                <td style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }}>
                  {order?.ProductPrice || "0.00"}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    borderTop: "1px solid black",

                    fontWeight: "bold",
                    textAlign: "center", verticalAlign: "middle",
                  }}
                  colSpan={2}
                ></td>
                <td
                  style={{
                    borderTop: "1px solid black",

                    fontWeight: "bold",
                    textAlign: "center", verticalAlign: "middle"
                  }}
                >
                  Order Total
                </td>
                <td
                  style={{
                    borderTop: "1px solid black",

                    fontWeight: "bold",
                    textAlign: "center", verticalAlign: "middle"
                  }}
                >
                  {order?.ProductPrice || "0.00"}
                </td>
              </tr>
            </tbody>
          </table> */}


          <div style={{ width: "100%", marginBottom: '8px' }}>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // Fixed camelCase
                width: "100%",
              }}
            >
              <p style={{ fontSize: "8px" }}>
                <span style={{ fontWeight: "bold" }}>SKU : </span>{" "}
                {order?.awb_number || "N/A"}
              </p>
              <p style={{ fontSize: "8px" }}>
                <span style={{ fontWeight: "bold" }}>Box Qty :</span>{" "}
                1
              </p>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // Fixed camelCase
                width: "100%",
              }}
            >
              <p style={{ fontSize: "8px" }}>
                <span style={{ fontWeight: "bold" }}>Item Name:</span>   {order?.ProductName || "N/A"}
              </p>

              <p style={{ fontSize: "8px" }}>
                <span style={{ fontWeight: "bold" }}>Order Total :</span>   {order?.ProductPrice || "0.00"}
              </p>
            </div>


          </div>
        </div>

        <div style={{ borderTop: '1px solid black', width: "100%" }}>
          <p style={{ fontSize: "8px", fontWeight: "bold" }}>
            {order?.pickupAddress?.name} <span style={{ fontSize: "8px", fontWeight: "normal" }}>(Pickup and Return Address)</span>
          </p>
          <p style={{ fontSize: "8px" }}>
            {order?.pickupAddress?.address1},
          </p>
          <p style={{ fontSize: "8px" }}>
            {order?.pickupAddress?.city}, {order?.pickupAddress?.stateId?.name} - {order?.pickupAddress?.zipCode}
          </p>
          <p style={{ fontSize: "8px" }}>Mobile No. <span style={{ fontSize: "8px", fontWeight: 'bold' }}> {order?.pickupAddress?.phone}</span></p>
        </div>
      </div>
    </div >
  );
});

export default CustomLabel;